module.exports = __webpack_public_path__ + "img/binance_api_ip_1.b269c7f8.png";